import { ReactNode } from "react";
import { Route } from "react-router-dom";
import { SlidePage } from "../components/ui/SlidePage";

export function getSlideRoute(path: string, child: ReactNode) {
  return <Route path={path} element={<SlidePage>{child}</SlidePage>}></Route>;
}
